
import { component } from '@/helpers/vueTyped';
import MenuItem from './MenuItem.vue';
import store, { dispatch } from '@/store';
import { TournamentSport } from '@/components/Sport/types';

export default component()({
  name: 'Menu',

  data() {
    return {
      lastFocusedMenuItem: undefined as HTMLElement | undefined,
    };
  },

  computed: {
    tournamentSports(): TournamentSport[] { return Object.values(store.state.tournaments); },
    open(): boolean { return store.state.drawerOpen; },
  },

  methods: {
    setLastItemFocused(event: FocusEvent): void {
      this.lastFocusedMenuItem = event.target as HTMLElement;
    },

    focus(): void {
      if (this.lastFocusedMenuItem) {
        this.lastFocusedMenuItem.focus();
      }
    },

    getMenuIcon(sport: string, type: 'active' | 'inactive') {
      return `/svg/drawer-menu/${sport}-${type}.svg`;
    },

    focusHomeMenu() {
      ((this.$refs.home as Vue).$el as HTMLElement).focus();
    },

    focusOnBack() {
      if (this.open) {
        this.focusHomeMenu();
        return;
      }

      dispatch('setDrawerOpenState', [true]);
      dispatch('setDrawerHidden', [false]);

      this.focus();
    },
  },

  async mounted() {
    this.focusHomeMenu();
  },

  created() {
    this.$spatialFocus.pushGlobalOverride('back', this.focusOnBack);
  },

  destroyed() {
    this.$spatialFocus.popGlobalOverride('back');
  },

  render() {
    return (
      <div
        v-spatial-container='menu'
        onFocus={this.focus}
        class='menu'
      >
        <MenuItem
          ref='home'
          nativeOnFocus={this.setLastItemFocused}
          iconActive={this.getMenuIcon('home', 'active')}
          iconInactive={this.getMenuIcon('home', 'inactive')}
          route='/'
          exact
          label='Home'
        />
        {this.tournamentSports.map((tournamentSport) => (
          <MenuItem
            key={tournamentSport.id}
            nativeOnFocus={this.setLastItemFocused}
            iconActive={this.getMenuIcon(tournamentSport.sport, 'active')}
            iconInactive={this.getMenuIcon(tournamentSport.sport, 'inactive')}
            route={`/${tournamentSport.id}/${tournamentSport.id}`}
            label={tournamentSport.label}
          />
        ))}
        {process.env.VUE_APP_DEPLOY_ENV !== 'production' &&
          <MenuItem
            key='environement-info'
            nativeOnFocus={this.setLastItemFocused}
            iconActive={this.getMenuIcon('', 'active')}
            iconInactive={this.getMenuIcon('', 'inactive')}
            route={'/environment-info'}
            label={'Env info'}
          />
        }
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a169b198/Menu.vue" });